import React, { Component } from 'react';
import { Fstyr } from '../../components/FstyrComponents/Fstyr.js';
import { fetchModel } from '../../components/HelperComponents/FetchExtension';
import { DateFormatter } from '../../components/HelperComponents/DateFormatter'
import { GetStatusName, GetStatusVm } from '../../components/HelperComponents/StatusHelper';
import { GetCprStatusName, GetCprStatusKode, IsCprStatusValidForNonDriverCards } from '../../components/HelperComponents/CprStatusHelper';
import { sortCardTableByDate, nameTooLong, getEkspeditionsType, localDateToUtcDate, isCardStatusValidForRenewal } from '../../components/HelperComponents/Helpers';
import { checkIfCardExpired, checkIfCardExpiresWitihinTwoMonths } from '../../components/HelperComponents/ValidityDateHelpers';
import URL from '../../Constants/URL.js'
import { BusinessVm } from '../../Models/BusinessVm';
import { BusinessCardVm } from '../../Models/BusinessCardVm';
import { ValidationType } from '../../Constants/ValidationTypes';
import { filterCardStatusesRenewed, filterCardStatusesReplaced } from '../../components/HelperComponents/FilterCardStatuses.js';
import { CardOrderBusinessCard } from '../../Models/CardOrderBusinessCard';
import { formatAddress } from '../../components/HelperComponents/AddressFormatter.js';

//#region CLASS/CONSTRUCTOR/STATE

enum orderType {
  foerstegangsudstedelse = "Førstegangsudstedelse",
  nyudstedelse = "Nyudstedelse",
  fornyelse = "Fornyelse",
  erstatning = "Erstatning",
  udskiftning = "Udskiftning"
}

type Props = {};

type State = {
  // input
  cvrBestilling: boolean,
  cvrOrCprInput: string,
  amountOfCards: number,
  orderType: orderType,
  nameOnCard: string,

  // validation 
  cvrOrCprInputIsValid: boolean,
  amountOfCardsIsValid: boolean,
  nameOnCardIsValid: boolean,
  dispensationIsOk: boolean | null,

  // Button press checks
  searchButtonPressed: boolean,
  orderButtonPressed: boolean,

  // options
  expressDelivery: boolean,
  deliveryToPlaceOfDispatch: boolean,
  placeOfDispatch: string,
  previousCardStatus: string,

  // logic
  showSpinner: boolean,
  openModal: boolean,
  openDispensationsModal: boolean,
  selectedCard: BusinessCardVm | null,
  validTo: Date | null,
  validFrom: Date | null,
  activeCardsFound: boolean,

  // fetched data
  businessVm: BusinessVm,
  businessCards: BusinessCardVm[],
};


export class CreateBusinessCard extends Component<Props, State> {
  static displayName = CreateBusinessCard.name;
  private toastRef: React.RefObject<any>;

  constructor(props: Props) {
    super(props);
    this.toastRef = React.createRef();

    this.state = {
      // input
      cvrBestilling: true,
      cvrOrCprInput: "",
      amountOfCards: 1,
      orderType: orderType.foerstegangsudstedelse,
      nameOnCard: "",

      // validation 
      cvrOrCprInputIsValid: false,
      amountOfCardsIsValid: true,
      nameOnCardIsValid: false,
      dispensationIsOk: null,

      // Button press checks
      searchButtonPressed: false,
      orderButtonPressed: false,

      // options
      expressDelivery: false,
      deliveryToPlaceOfDispatch: false,
      placeOfDispatch: "",
      previousCardStatus: "",

      // logic
      showSpinner: false,
      openModal: false,
      openDispensationsModal: false,
      selectedCard: null,
      validTo: null,
      validFrom: null,
      activeCardsFound: false,

      // fetched data
      businessVm: new BusinessVm(),
      businessCards: [],
    };
  }

  componentDidMount() {
    this.setValidityPeriod()
  }


  componentDidUpdate(prevProps: Props, prevState: State) {

    if (prevState.orderType !== this.state.orderType || prevState.selectedCard !== this.state.selectedCard) {
      if (prevState.selectedCard !== this.state.selectedCard) {
        this.setState({ orderType: this.getRadiobuttons()[0] }, () =>
          this.setValidityPeriod())
      }
      else {
        this.setValidityPeriod()
      }
    }
    if (prevState.businessVm !== this.state.businessVm) {
      this.setState({ nameOnCard: this.state.businessVm.Name })
    }
  }

  //#endregion

  //#region API CALLS

  fetchBusiness() {
    this.setState({ searchButtonPressed: true }, () => {
      if (this.state.cvrOrCprInputIsValid) {
        this.clearPage(false);
        this.setState({ showSpinner: true });
        fetchModel("GET", URL + "/api/BusinessCard/GetBusinessCardsByCvr", this.state.cvrOrCprInput, BusinessCardVm)
          .then(model => {
            this.handleBusinessSearchResults(model)
          })
          .catch(error => {
            if (error !== "No result") {
              this.showErrorToast(error, "et virksomhedskort");
            }
          })
          .finally(() => {
            this.setState({ showSpinner: false }, () => {
              this.fetchBusinessVm()
              this.checkForWorkshopcards()
            })
          })
      }
    })
  }

  fetchBusinessVm() {
    this.setState({ showSpinner: true })
    fetchModel("GET", URL + "/api/BusinessCard/GetBusinessByCvrOrCpr", this.state.cvrOrCprInput, BusinessVm)
      .then(model => {
        if (model[0].Cvr && model[0].Cvr !== "0") {
          this.setState({ businessVm: model[0] },
            () => {
              if (!this.state.cvrBestilling) {
                this.handleCprStatus()
              }
            })
        } else {
          var temp = this.state.cvrBestilling ? "en virksomhed" : "en person"
          this.showErrorToast("No result", temp);
        }
      })
      .catch(error => {
        var temp = this.state.cvrBestilling ? "en virksomhed" : "en person"
        this.showErrorToast(error, temp);
      })
      .finally(() => {
        this.setState({ showSpinner: false })
      })
  }

  checkForWorkshopcards() {
    if (this.state.cvrBestilling) {
      this.setState({ showSpinner: true });

      fetch(URL + `/api/WorkshopCard/CheckForActiveWorkshopCardsByCvr/${this.state.cvrOrCprInput}`, {
        headers: {
          'Content-Type': 'application/json'
        },
        method: 'GET',
      })
        .then(response => response.json())
        .then((result) => {
          if (result) {
            this.setState({ openDispensationsModal: true, dispensationIsOk: false })
          }
        })
        .catch(error => {
          this.toastRef.current.show("Fejl i søgning", "Det var ikke muligt at checke om cvr nummeret har et værkstedskort tilknyttet.", "warning")
          console.error(error)
        });
    }
  }

  fetchCreateCard() {
    var model = new CardOrderBusinessCard()
    model.KortType = "V";
    model.OrdreType = this.state.expressDelivery ? "1" : "0";
    model.SendTilEkspeditionssted = this.state.deliveryToPlaceOfDispatch;
    model.GebyrFrit = false;
    model.UdstedelsesDato = new Date();
    model.EkspeditionsType = getEkspeditionsType(this.state.orderType);
    model.KortEjerNavn = this.state.nameOnCard;
    model.KortEjerAdresse = formatAddress(this.state.businessVm.Address, true);

    model.PostAdresseNavn = this.state.nameOnCard;
    model.PostAdresseVejOgNr = this.state.businessVm.Address.StreetNameAndNumber;
    model.PostAdresseStedNavn = this.state.businessVm.Address.PlaceName;
    model.PostAdressePostNr = this.state.businessVm.Address.PostalCode;
    model.PostAdressePostDistrikt = this.state.businessVm.Address.City;
    model.GyldighedStartDato = localDateToUtcDate(this.state.validFrom);
    model.UdloebsDato = localDateToUtcDate(this.state.validTo);

    if (this.state.selectedCard && !this.isCardNyOrForstegang()) {
      model.KortNrTidligereKort = this.state.selectedCard.CardNumber;
    }

    model.UdstedendeMyndighed = this.state.deliveryToPlaceOfDispatch ? this.state.placeOfDispatch.substring(0, 4) : "2001";
    model.IsAndenGeneration = "true";
    model.CvrNr = this.state.businessVm.Cvr;
    model.Antal = this.state.amountOfCards.toString();
    fetch(URL + "/api/businesscard/createOrder/", {
      headers: {
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(model)
    })
      .then(response => response.json())
      .then((result) => {
        if (result.valid) {
          if (!this.isCardNyOrForstegang()) { this.setStatusOfPreviousCard() }
          this.clearPage(true)
          this.showSuccessToast()
          this.setState({ openModal: false })
        }
        else if (result.errors.length > 0) {
          this.showErrorToast(result.errors[0].exception, result.errors[0].message)
        }
        else
          this.showErrorToast("error", "")

      })
      .catch(error => console.error(error));

  }

  isCardNyOrForstegang() {
    return this.state.orderType === orderType.foerstegangsudstedelse || this.state.orderType === orderType.nyudstedelse
  }

  setStatusOfPreviousCard() {
    let model = Object.assign({}, this.state.selectedCard);

    model.Status = GetStatusVm(this.state.previousCardStatus)
    let success = true;

    let requestInfo = {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(model)
    }
    fetch(URL + "/api/businesscard/ChangeCardStatus", requestInfo)
      .then(response => response.json())
      .then((result) => {
        if (!result.valid) {
          success = false
        }
      })
      .catch(() => {
        success = false;
      })
      .finally(
        () => {
          if (!success) this.toastRef.current.show("Fejl", `Status på tidligere kort (${model.CardNumber}) blev ikke opdateret.`, "error")
        }
      )
  }

  //#endregion

  //#region API RESPONSE MAPPING

  handleBusinessSearchResults(result: BusinessCardVm[]) {
    this.setState({
      businessCards: sortCardTableByDate(result),
      activeCardsFound: result.some((el) => this.checkCardValidForRenewal(el))
    }, () => {
      this.onRowSelected(null)
      this.setState({ orderType: this.getRadiobuttons()[0] })
    })
  }

  checkCardValidForRenewal(card: BusinessCardVm) {
    return isCardStatusValidForRenewal(card.Status.Id)
  }


  handleCprStatus() {
    if (!IsCprStatusValidForNonDriverCards(this.state.businessVm.CprStatus)) {
      this.toastRef.current.show("CPR Status", `Personer med status ${GetCprStatusKode(this.state.businessVm.CprStatus)} kan ikke bestille kort.`, "warning")
    }
  }
  //#endregion

  //#region  GUI EVENTS HANDLING
  getSelectedCard(cardNumber: string): BusinessCardVm | null {
    return this.state.businessCards.find(card => card.CardNumber === cardNumber) ?? null
  }


  onRowSelected(row: string[] | null) {
    let card = row ? this.getSelectedCard(row[0]) : null

    this.setState({ selectedCard: card }, () => {
      this.setState({ orderType: this.getRadiobuttons()[0] },
        () => this.setValidityPeriod()
      )
    })
  }

  setValidityPeriod() {
    let newValidFrom: Date | null = null
    let newValidTo: Date | null = null
    switch (this.state.orderType) {
      case orderType.foerstegangsudstedelse:
      case orderType.nyudstedelse:
        newValidFrom = new Date()
        newValidTo = new Date()
        newValidTo.setFullYear(newValidTo.getFullYear() + 5)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      case orderType.fornyelse:
        if (checkIfCardExpired(this.state.selectedCard)) {
          newValidFrom = new Date()
        } else {
          newValidFrom = new Date(this.state.selectedCard?.ValidTo ?? -1)
          newValidFrom.setDate(newValidFrom.getDate() + 1)
        }
        newValidTo = new Date(newValidFrom)
        newValidTo.setFullYear(newValidFrom.getFullYear() + 5)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      case orderType.erstatning:
        newValidFrom = new Date(Math.max(Number(new Date()), Number(new Date(this.state.selectedCard?.ValidFrom ?? -1))))
        newValidTo = new Date(this.state.selectedCard?.ValidTo ?? -1)
        break;
      case orderType.udskiftning:
        newValidFrom = new Date(Math.max(Number(new Date()), Number(new Date(this.state.selectedCard?.ValidFrom ?? -1))))
        newValidTo = new Date()
        newValidTo.setFullYear(newValidTo.getFullYear() + 5)
        newValidTo.setDate(newValidTo.getDate() - 1)
        break;
      default:
    }
    this.setState({ validFrom: newValidFrom, validTo: newValidTo })
  }


  getRadiobuttons(): orderType[] {
    if (this.state.businessCards.length > 0 && this.state.activeCardsFound) {
      if (this.state.selectedCard) {
        if (checkIfCardExpired(this.state.selectedCard)) {
          if (this.state.activeCardsFound)
            return [orderType.fornyelse]
          else
            return [orderType.foerstegangsudstedelse]
        }
        else if (checkIfCardExpiresWitihinTwoMonths(this.state.selectedCard)) {
          return [orderType.fornyelse, orderType.erstatning, orderType.udskiftning]
        }
        else {
          return [orderType.erstatning, orderType.udskiftning]
        }
      }
      return [orderType.nyudstedelse]
    }
    return [orderType.foerstegangsudstedelse]
  }

  isPlaceOfDispatchValid() {
    if (this.state.deliveryToPlaceOfDispatch) {
      return this.state.placeOfDispatch.length > 0;
    } else {
      return true;
    }
  }

  isPreviousCardStatusValid() {
    var ordertypesWithStatusChange = [orderType.erstatning, orderType.fornyelse, orderType.udskiftning]
    if (ordertypesWithStatusChange.includes(this.state.orderType)) {
      return this.state.previousCardStatus.length > 0
    }
    return true
  }

  validateOrder() {
    this.setState({ orderButtonPressed: true })
    if (!this.state.businessVm.Name) {
      this.toastRef.current.show("Se bestilling", "Virksomhedsinformationer mangler, søg på gyldigt cvr eller cpr.", "error")
      return false;
    }

    let orderIsValid: boolean = true;
    let errorMessage: string[] = [];

    if (!this.state.cvrBestilling && !IsCprStatusValidForNonDriverCards(this.state.businessVm.CprStatus)) {
      errorMessage.push("person med gyldig status")
      orderIsValid = false
    }
    if (this.state.dispensationIsOk === false) { /// explicit check because null means no disp is needed.
      this.toastRef.current.show("Fejl i CVR", "Cvr nummeret har et værkstedskort tilknyttet og dispensation er ikke godkendt, søg på cvr igen for at godkende dispensation..", "error")
      orderIsValid = false;
    }
    if (!this.isPreviousCardStatusValid()) {
      errorMessage.push("ny status på tidligere kort")
      orderIsValid = false;
    }
    if (this.state.orderType === orderType.nyudstedelse || this.state.orderType === orderType.foerstegangsudstedelse) {
      if (!this.state.amountOfCardsIsValid) {
        errorMessage.push("antal kort")
        orderIsValid = false;
      }
    }
    if (!this.isPlaceOfDispatchValid()) {
      errorMessage.push("lokation")
      orderIsValid = false;
    }
    if (nameTooLong(this.state.nameOnCard) && !this.state.nameOnCardIsValid) {
      errorMessage.push("navn på kort")
      orderIsValid = false;
    }

    if (orderIsValid) {
      this.setState({ openModal: true })
    } else {
      this.showValidationErrorToast(errorMessage)
    }
  }

  showValidationErrorToast(errorMessage: string[]) {
    errorMessage[0] = errorMessage[0].charAt(0).toUpperCase() + errorMessage[0].slice(1);
    var errorString = errorMessage.reduce(function (p, d, i) {
      return p + (i === errorMessage.length - 1 ? ' og ' : ', ') + d;
    });
    errorString += " mangler."
    this.toastRef.current.show("Se bestilling", errorString, "error")
  }

  clearPage(clearinput: boolean) {
    if (clearinput) {
      this.setState({
        cvrBestilling: true,
        cvrOrCprInput: "",
        cvrOrCprInputIsValid: false,
      })
    }

    this.setState({
      // input
      //cvrBestilling: true,
      //cvrOrCprInput: "",
      amountOfCards: 1,
      orderType: orderType.foerstegangsudstedelse,
      nameOnCard: "",

      // validation 
      //cvrOrCprInputIsValid: false,
      amountOfCardsIsValid: true,
      nameOnCardIsValid: false,
      dispensationIsOk: null,

      // Button press checks
      searchButtonPressed: false,
      orderButtonPressed: false,

      // options
      expressDelivery: false,
      deliveryToPlaceOfDispatch: false,
      placeOfDispatch: "",
      previousCardStatus: "",

      // logic
      showSpinner: false,
      openModal: false,
      openDispensationsModal: false,
      selectedCard: null,
      //validTo: null,
      //validFrom: null,
      activeCardsFound: false,

      // fetched data
      businessVm: new BusinessVm(),
      businessCards: [],
    })
  }

  showSuccessToast() {
    this.toastRef.current.show("Success", "Din bestilling er oprettet. ", "success")
  }

  showErrorToast(error: string, message: string) {
    this.setState({ showSpinner: false })
    if (error === "Failed response") {
      this.toastRef.current.show("Fejl", "Kan ikke forbinde til databasen", "error")
    }
    else if (error === "No result" && message) {
      this.toastRef.current.show("Virksomhed", `Der findes ikke ${message} med det søgte nummer`, "warning")
    }
    else {
      this.toastRef.current.show("Fejl", "Der skete en ukendt fejl", "error")
      console.error(error)
    }
  }

  showCprStatusWarning() {
    return this.state.orderButtonPressed
      && !IsCprStatusValidForNonDriverCards(this.state.businessVm.CprStatus)
  }

  checkboxDisabled(i: number) {
    let card = this.state.businessCards[i]
    return !this.checkCardValidForRenewal(card)
  }


  //#endregion

  //#region GUI/RENDER

  render() {
    return (
      <>
        <Fstyr.Toast ref={this.toastRef} />
        <Fstyr.Modal
          show={this.state.openModal}
          onDecline={() => { this.setState({ openModal: false }) }}
          onAccept={() => { this.fetchCreateCard() }}
          label="Bestil virksomhedskort"
          buttonGroupLabel="Bestil virksomhedskort"
          buttonAcceptLabel="Bestil"
          buttonDeclineLabel="Annullér"
          layout={[
            {
              "label": "Virksomhedsinformationer",
              "inputs": [
                { "label": this.state.cvrBestilling ? "CVR" : "CPR", "value": this.state.businessVm.Cvr },
                { "label": this.state.cvrBestilling ? "Virksomhedsnavn" : "Navn", "value": this.state.nameOnCard },
                { "label": this.state.cvrBestilling ? "CVR adresse" : "CPR adresse", "value": formatAddress(this.state.businessVm.Address, true) }
              ]
            },
            {
              "label": "Bestillingsinformationer",
              "inputs": [
                { "label": "Type", "value": this.state.orderType },
                { "label": "Antal kort", "value": this.state.amountOfCards },
                { "label": "Gyldighedsperiode", "value": DateFormatter(this.state.validFrom) + " til " + DateFormatter(this.state.validTo) },
                { "label": "Ekspreslevering", "value": this.state.expressDelivery ? "Ja" : "Nej" },
                { "label": "Levering af virksomhedskort til ekspeditionssted", "value": this.state.deliveryToPlaceOfDispatch ? this.state.placeOfDispatch : "Nej" }
              ]
            }
          ]}
        />

        <Fstyr.Modal
          show={this.state.openDispensationsModal}
          onDecline={() => this.clearPage(true)}
          onAccept={() => { this.setState({ openDispensationsModal: false, dispensationIsOk: true }) }}
          label="Advarsel!"
          buttonAcceptLabel="Godkend"
          buttonDeclineLabel="Annullér"
          layout={[
            {
              "inputs": [
                { "label": "Værkstedskort fundet", "value": "Der skal foreligge dispensation" },
              ]
            }
          ]}
        />

        <Fstyr.Segment
          title="Opret Virksomhedskort"
          isPageTitle={true}
        >
          <div className="fstyr-right-top-button-group">
            <Fstyr.Button
              label="Ryd side"
              onClick={() => { this.clearPage(true) }}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title={this.state.cvrBestilling ? "Angiv CVR" : "Angiv CPR"}
        >
          <Fstyr.RadioButtonGroup
            label="Angiv type af bestilling"
            choices={["Erhverv", "Privat"]}
            value={this.state.cvrBestilling ? "Erhverv" : "Privat"}
            onClick={(value: string) => {
              this.clearPage(true)
              this.setState({ cvrBestilling: (value === "Erhverv") });
            }}
          />
          {this.state.cvrBestilling ?
            <Fstyr.Input
              value={this.state.cvrOrCprInput}
              direction='column'
              label="CVR nummer"
              onChange={(value: string) => this.setState({ cvrOrCprInput: value })}
              validation={true}
              validationType={ValidationType.cvr}
              setValid={(valid: boolean) => this.setState({ cvrOrCprInputIsValid: valid })}
              onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
              errorBodyText={"Skal være 8 cifre langt"}
              errorExampleText={"f.eks. 12345678"}
              buttonClicked={this.state.searchButtonPressed}
              onEnterPressed={() => this.fetchBusiness()}
            />
            :
            <Fstyr.Input
              value={this.state.cvrOrCprInput}
              direction='column'
              label="CPR nummer"
              onChange={(value: string) => this.setState({ cvrOrCprInput: value })}
              validation={true}
              validationType={ValidationType.cpr}
              setValid={(valid: boolean) => this.setState({ cvrOrCprInputIsValid: valid })}
              onValidatingButtonPressed={() => this.setState({ searchButtonPressed: true })}
              errorBodyText={"Skal være 10 cifre langt"}
              errorExampleText={"f.eks. 0101901234"}
              buttonClicked={this.state.searchButtonPressed}
              onEnterPressed={() => this.fetchBusiness()}
            />
          }
          <div className="fstyr-left-button-group">
            <Fstyr.Button
              label="Søg"
              onClick={() => {
                this.fetchBusiness()
              }}
              disabled={this.state.showSpinner}
            />
            <div style={{ width: 20 }} />
            <Fstyr.Spinner
              show={this.state.showSpinner}
            />
          </div>
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Virksomhedsinformation"
        >
          <p className="fstyr-header-info">Virksomhedsoplysninger</p>
          <div className="fstyr-attention-box">
            <Fstyr.Input
              label={this.state.cvrBestilling ? "CVR" : "CPR"}
              readonly={true}
              value={this.state.businessVm.Cvr}
              direction="row"
            />
            {!this.state.cvrBestilling &&
              <div className={this.showCprStatusWarning() ? "form-group form-error" : ""}>
                <Fstyr.Input
                  label="Status"
                  readonly={true}
                  value={GetCprStatusName(this.state.businessVm.CprStatus)}
                  direction="row"
                />
                {this.showCprStatusWarning() && (
                  <span className="form-error-message" id="form-error-error">
                    {`For at bestille et førerkort må status ikke være ${GetCprStatusKode(this.state.businessVm.CprStatus)}`}
                  </span>
                )}
              </div>
            }
            <Fstyr.Input
              label={this.state.cvrBestilling ? "Virksomhedsnavn" : "Navn"}
              readonly={true}
              value={this.state.businessVm.Name}
              direction="row"
            />
            <Fstyr.Input
              label={this.state.cvrBestilling ? "CVR Adresse" : "CPR Adresse"}
              readonly={true}
              value={formatAddress(this.state.businessVm.Address, true)}
              direction="row"
            />
          </div>
          <Fstyr.SelectableTable
            label="Registreret virksomhedskort"
            headers={["Kortnr.", "Navn", "Startdato", "Udløbsdato", "Status"]}
            data={this.state.businessCards.map(function (card) {
              return [
                card.CardNumber,
                card.BusinessName,
                DateFormatter(card.ValidFrom),
                DateFormatter(card.ValidTo),
                GetStatusName(card.Status.NameDK)
              ]
            })}
            note={"Virksomhed har " + this.state.businessCards.length + " registreringer på virksomhedskort"}
            path={"businessCard"}
            onRowSelected={(row: string[]) => this.onRowSelected(row)}
            useCustomDisableCheckboxFunction={true}
            disableCheckbox={(index: number) => this.checkboxDisabled(index)}
            preSelect={false}
            tableName="danishResultsTable"
            useLinks={true}
          />
        </Fstyr.Segment>
        <Fstyr.Segment
          title="Bestilling"
        >
          {
            this.state.dispensationIsOk &&
            <span className="badge badge-small badge-warning" style={{ marginBottom: "15px", textTransform: "inherit" }}>Dispensation er godkendt af sagsbehandler.</span>
          }
          <Fstyr.RadioButtonGroup
            label="Angiv type af bestilling"
            choices={this.getRadiobuttons()}
            value={this.state.orderType}
            onClick={(value: string) => this.setState({ orderType: value as orderType })}
          />
          {/*Status på tidligere kort*/}
          <div className={(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) ? "form-group form-error" : ""}>

            {(this.state.orderType === orderType.fornyelse || this.state.orderType === orderType.udskiftning) &&
              <Fstyr.Dropdown
                items={filterCardStatusesRenewed(require('../../assets/CardStatus.json'))}
                width={320}
                onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                label="Status på tidligere kort"
              />
            }
            {
              (this.state.orderType === orderType.erstatning) &&
              <Fstyr.Dropdown
                items={filterCardStatusesReplaced(require('../../assets/CardStatus.json'))}
                width={320}
                onItemSelected={(value) => this.setState({ previousCardStatus: value })}
                label="Status på tidligere kort"
              />
            }
            {(this.state.orderButtonPressed && !this.isPreviousCardStatusValid()) && (
              <span className="form-error-message" id="form-error-error">
                {"Status skal udfyldes"}
              </span>
            )}
          </div>

          {
            (this.state.orderType === orderType.nyudstedelse || this.state.orderType === orderType.foerstegangsudstedelse) &&
            <Fstyr.Input
              value={this.state.amountOfCards.toString()}
              direction='column'
              label="Antal kort"
              onChange={(value: string) => this.setState({ amountOfCards: parseInt(value) ?? 0 })}
              validation={true}
              validationType={ValidationType.amountOfCards}
              setValid={(valid: boolean) => this.setState({ amountOfCardsIsValid: valid })}
              onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
              errorBodyText={"Skal være et tal mellem 1 og 5"}
              type={"number"}
            />

          }
          <p className="fstyr-text-header">Leveringsinformation</p>
          <Fstyr.Checkbox
            label="Ekspreslevering"
            checked={this.state.expressDelivery}
            onClick={(value) => this.setState({ expressDelivery: value })}
          />
          <Fstyr.Checkbox
            label="Levering af virksomhedskort til ekspeditionssted"
            checked={this.state.deliveryToPlaceOfDispatch}
            onClick={(value) => this.setState({ deliveryToPlaceOfDispatch: value })}
          />

          {this.state.deliveryToPlaceOfDispatch &&
            <div className={(this.state.orderButtonPressed && !this.state.placeOfDispatch) ? "form-group form-error" : ""}>
              <Fstyr.Dropdown
                items={["2001 - København", "2002 - Kolding", "2003 - Aalborg"]}
                width={300}
                onItemSelected={(value) => this.setState({ placeOfDispatch: value })}
                label="Lokation"
              />
              {(this.state.orderButtonPressed && !this.state.placeOfDispatch) &&
                <span className="form-error-message" id="form-error-error">
                  {"Lokation skal udfyldes"}
                </span>
              }
            </div>
          }

          {nameTooLong(this.state.businessVm.Name) &&
            <Fstyr.Input
              value={this.state.nameOnCard}
              direction='column'
              label="Navn på kort"
              onChange={(value: string) => this.setState({ nameOnCard: value })}
              validation={true}
              validationType={ValidationType.textWithSpacesAndNumbersMax35}
              setValid={(valid: boolean) => this.setState({ nameOnCardIsValid: valid })}
              buttonClicked={true} // hardcoded to ensure validation always active
              onValidatingButtonPressed={() => this.setState({ orderButtonPressed: true })}
              errorBodyText={this.state.cvrBestilling ?
                "Navnet er for langt til at stå på kortet, rediger navnet så det indeholder under 35 tegn. Husk at virksomhedstype (ApS, A/S, ...) skal bevares."
                : "Personens navn er for langt til at stå på kortet, rediger navnet så det indeholder under 35 tegn."}
              errorExampleText={this.state.cvrBestilling ?
                "f.eks. Transportselskabet Konstantino. ApS"
                : "f.eks. Anna B. C. D. Eriksen"
              }
            />}

        </Fstyr.Segment>
        <Fstyr.Segment
          title="Bestillingsinformation"
        >
          <Fstyr.Button
            label="Se bestilling"
            onClick={() => this.validateOrder()}
          />
        </Fstyr.Segment>
        <Fstyr.Segment
          title=""
          isPageTitle={true}
        />
      </>
    );
  }
}

//#endregion
